import PropTypes from 'prop-types';
import React from 'react';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import CustomTooltip from '../CustomTooltip';
import CustomLabel from '../CustomLabel';
import { primaryColorObj, secondaryColorObj } from '../../../../themes';

const CustomToggleButton = ({
  label,
  value,
  handleChange,
  options,
  minWidth = '90px',
}) => {
  return (
    <Stack>
      {label && <CustomLabel noMarginTop>{label}</CustomLabel>}
      <ToggleButtonGroup
        size="small"
        sx={{
          '.MuiToggleButton-root': {
            color: 'white',
            backgroundColor: secondaryColorObj.default,
            '&.Mui-selected': {
              backgroundColor: primaryColorObj.default,
            },

            '&:hover': {
              backgroundColor: theme => theme.palette.primary.dark,
            },
          },
        }}
        value={value}
        exclusive
        onChange={handleChange}
      >
        {options.map(opt => (
          <CustomTooltip key={opt.value} title={opt.label}>
            <ToggleButton
              value={opt.value}
              selected={opt.value === value}
              sx={{
                minWidth,
                pointerEvents: opt.value === value ? 'none' : 'auto',
              }}
            >
              {opt.content}
            </ToggleButton>
          </CustomTooltip>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

CustomToggleButton.propTypes = {
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  minWidth: PropTypes.string,
};

export default CustomToggleButton;
